module.exports = "/images/bg-about-us.png?a5b65f5429cc8029a340bb8f9f8c9e1f";